import $ from 'jquery'
export { getSelectedText, getSelection, toggleCopyOnBody, dispatchCopyEventFrom, getVisuallyHiddenText, removeScreenReaderText }

let preventCopyOnBodyApplied = false
function preventEventHandler(evt) {
  console.log('copy on body prevented')
  evt.preventDefault()
}

function getSelectedText() {
  var txt = ''
  if (window.getSelection) {
    txt = window.getSelection().toString()
  } else if (document.getSelection) {
    txt = document.getSelection().toString()
  } else if (document.selection) {
    txt = document.selection.createRange().text
  }
  return txt
}

function getSelection() {
  let selection = null
  if (window.getSelection) {
    selection = window.getSelection()
  } else if (document.getSelection) {
    selection = document.getSelection()
  }
  return selection
}

// true means detach prevent handler body element
// false means attach prevent handler
function toggleCopyOnBody(allowFlag) {
  if (!allowFlag && !preventCopyOnBodyApplied) {
    console.log('disabling copy on body element')
    $(document.body).on('copy', preventEventHandler)
    preventCopyOnBodyApplied = true
  }
  if (allowFlag && preventCopyOnBodyApplied) {
    console.log('allowing copy on body element')
    $(document.body).off('copy', preventEventHandler)
    preventCopyOnBodyApplied = false
  }
}

// simulates a copy event; useful when we programmatically perform a copy (e.g. via a Copy button) but still want to trigger a browser copy event
function dispatchCopyEventFrom(domElm, fromButton) {
  if (domElm) {
    let evtOptions = {
      bubbles: true,
      cancelable: true,
      detail: { fromButton: !!fromButton }
    }
    let evt = new CustomEvent('copy', evtOptions)
    domElm.dispatchEvent(evt)
  }
}

const hiddenStyleString = 'clip:rect(0 0 0 0); clip-path:inset(50%); height:1px; overflow:hidden; position:absolute; white-space:nowrap; width:1px;'

// Creates a visually hidden element for status messages that screen readers can announce.
const getVisuallyHiddenText = text => {
  const visuallyHiddenText = document.createElement('span')
  visuallyHiddenText.textContent = text
  visuallyHiddenText.setAttribute('class', 'visually-hidden')
  visuallyHiddenText.setAttribute('role', 'status')
  visuallyHiddenText.setAttribute('style', hiddenStyleString)
  return visuallyHiddenText
}

function removeScreenReaderText(selectedText) {
    // Removes hidden text (ex. (Opens in a new tab)) for screen reader and extra surrounding whitespaces
    const srOnlyElements = document.querySelectorAll('.sr-only')
    if (srOnlyElements.length > 0) {
      srOnlyElements.forEach(el => {
        const srOnlyText = el.innerText
        selectedText = selectedText.replace(new RegExp(`\\s*\\(${srOnlyText}\\)\\s*(?=[.,!?:;])|\\(${srOnlyText}\\)\\s+`, 'g'), '')
      })
    }
    return selectedText
}
